import { put, takeLatest, call } from 'redux-saga/effects';
import {
  GET_ROSTER_ADHERENCE,
  GET_CLIENT_ADHERENCE,
} from './constants';
import {
  getRosterAdherenceSuccess,
  getRosterAdherenceError,
  getClientAdherenceSuccess,
  getClientAdherenceError,
} from './actions';
import { fetchData } from '../api';

function authConfig() {
  return {
    headers: {
      'x-auth-token': window.localStorage.token,
      'Content-Type': 'application/json',
    },
  };
}

export function* getRosterAdherence({ weeks }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/adherence/roster?weeks=${weeks || 8}`;
    const data = yield call(fetchData, url, authConfig());
    yield put(getRosterAdherenceSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(getRosterAdherenceError(error));
  }
}

export function* getClientAdherence({ clientId, weeks }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/adherence/client/${clientId}?weeks=${weeks || 8}`;
    const data = yield call(fetchData, url, authConfig());
    yield put(getClientAdherenceSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(getClientAdherenceError(error));
  }
}

export default function* adherenceSaga() {
  yield takeLatest(GET_ROSTER_ADHERENCE, getRosterAdherence);
  yield takeLatest(GET_CLIENT_ADHERENCE, getClientAdherence);
}
